export default __webpack_public_path__ + "static/media/file_download.a347b7e0.svg";